// extracted by mini-css-extract-plugin
export default {"scrollMobile":"scroll_scrollMobile__d0MrV","content":"scroll_content__N+F3v"};